const {
  SYNTHETIC_TEST_EMAIL_REGEX,
  SYNTHETIC_TEST_COMPANYNAME_REGEX,
  DATADOG_TEST_EMAIL_REGEX,
  E2E_MULTI_TEAM_EMAIL,
  E2E_SINGLE_TEAM_EMAIL
} = require('../../constants')

const isSyntheticTestAccount = (companyName, companyEmail) => {
  const isTestCompanyName = SYNTHETIC_TEST_COMPANYNAME_REGEX.test(companyName)
  const isTestCompanyEmail = SYNTHETIC_TEST_EMAIL_REGEX.test(companyEmail) || DATADOG_TEST_EMAIL_REGEX.test(companyEmail)
  const isSyntheticTestCompany = isTestCompanyName && isTestCompanyEmail
  return isSyntheticTestCompany
}

const isE2ETestAccount = (companyEmail) => {
  const isE2ECompany = companyEmail === E2E_MULTI_TEAM_EMAIL || companyEmail === E2E_SINGLE_TEAM_EMAIL
  return isE2ECompany
}

module.exports = {
  isSyntheticTestAccount,
  isE2ETestAccount
}
